import { render, staticRenderFns } from "./Whats.component.html?vue&type=template&id=be23e5ee&"
import script from "./Whats.vue?vue&type=script&lang=ts&"
export * from "./Whats.vue?vue&type=script&lang=ts&"
import style0 from "./Whats.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports